import { render } from "./phoneHeader.vue?vue&type=template&id=6b63e18c&scoped=true"
import script from "./phoneHeader.vue?vue&type=script&lang=js"
export * from "./phoneHeader.vue?vue&type=script&lang=js"

import "./phoneHeader.vue?vue&type=style&index=0&id=6b63e18c&lang=css"
import "./phoneHeader.vue?vue&type=style&index=1&id=6b63e18c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_e1bdad7a4b23a28f51493789fcc92ed5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b63e18c"]])

export default __exports__